import { type Event } from '@bugsnag/core/types';
import Bugsnag from '@bugsnag/js';
import { type EnvironmentSettings } from '@reconcept-platform/env';
import { sanitizedKeys } from './filter_parameter_logging';

export function initBugsnag(environmentSettings: EnvironmentSettings): () => void {
  if (environmentSettings.production && !Bugsnag.isStarted()) {
    Bugsnag.start({
      // @ts-expect-error TS2322 type not assignable
      apiKey: environmentSettings.bugsnagApiKey,
      releaseStage: environmentSettings.environment,
      appVersion: environmentSettings.version,
      redactedKeys: sanitizedKeys,
      onError: markResizeObserverLoop,
    });
  }
  return () => {};
}

// The browser reports it as a window error, which Bugsnag catches itself as unhandled.
// It is harmless (the browser delivers the remaining notifications next frame), so it shouldn't count as a crash.
export function markResizeObserverLoop(event: Event) {
  if (event.errors.some(({ errorMessage }) => /ResizeObserver loop/.test(errorMessage))) {
    event.severity = 'info';
    event.unhandled = false;
    event.groupingHash = 'resize-observer-loop';
  }
}
